import { SVGProps } from 'react';

const GotMailIcon = ({
  height = '115px',
  width = '115px',
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={width}
    height={height}
    viewBox='0 0 115 115'
    {...props}
  >
    <g transform='translate(-366.639 -409.238)'>
      <circle
        cx='57.5'
        cy='57.5'
        r='57.5'
        transform='translate(366.639 409.238)'
        fill='#dff8d4'
      />
      <circle
        cx='45'
        cy='45'
        r='45'
        transform='translate(378.638 422.238)'
        fill='#60b96b'
        opacity='0.23'
      />
      <path
        d='M26.833,0H2.981A2.978,2.978,0,0,0,.015,2.981L0,20.87a2.99,2.99,0,0,0,2.981,2.981H26.833a2.99,2.99,0,0,0,2.981-2.981V2.981A2.99,2.99,0,0,0,26.833,0Zm0,5.963L14.907,13.417,2.981,5.963V2.981l11.926,7.454L26.833,2.981Z'
        transform='translate(404.596 462.136) rotate(-17)'
        fill='#60b96b'
      />
      <path
        d='M26.833,0H2.981A2.978,2.978,0,0,0,.015,2.981L0,20.87a2.99,2.99,0,0,0,2.981,2.981H26.833a2.99,2.99,0,0,0,2.981-2.981V2.981A2.99,2.99,0,0,0,26.833,0Zm0,5.963L14.907,13.417,2.981,5.963V2.981l11.926,7.454L26.833,2.981Z'
        transform='translate(407.195 457.248) rotate(-17)'
        fill='#fff'
        stroke='#60b96b'
        strokeWidth='1.5'
      />
    </g>
  </svg>
);

export default GotMailIcon;
